/* eslint-disable no-console */

/* Polyfill */
if (typeof window.setImmediate !== 'function') {
	window.setImmediate = require('asap');
}

import Queue from 'better-queue';
import $ from 'jquery';

// @ts-ignore
import MemoryStore from 'better-queue-memory';

interface Email {
	// eslint-disable-next-line camelcase
	form_id: number;
	// eslint-disable-next-line camelcase
	entry_id: string;
	to: string;
	subject: string;
	message: string;
	header: string;
	[key: string]: any;
}

type Emails = Email[];

class GPEmailUsers {
	public spinner: any;
	public connThreshold: number;
	public debug: any;
	public retryMax: number = 5;
	public queue: Queue;

	constructor() {
		this.connThreshold = window.GPEU.connThreshold;
		this.debug = window.GPEU.debug;

		this.spinner = new window.gperk.ajaxSpinner(
			'.gpeu-sending .gpeu-sending_count',
			window.GPEU.spinnerUrl
		);

		this.queue = new Queue(this.sendEmail, {
			maxRetries: this.retryMax,
			retryDelay: 1000,
			concurrent: this.connThreshold,
			store: new MemoryStore(),
		})
			.on('task_queued', this.taskQueued)
			.on('task_finish', this.taskFinish)
			.on('task_failed', this.taskFailed)
			.on('task_finish', this.updateCounter)
			.on('task_failed', this.updateCounter)
			.on('drain', this.drain);

		$(this.bind);
	}

	bind = () => {
		$('#gform-settings-gpeu-send').on('click', this.sendEmails);

		$('.gpeu-pause-sending').on('click', this.pause);
		$('.gpeu-resume-sending').on('click', this.resume);
	};

	pause = (event: Event) => {
		event.preventDefault();

		this.queue.pause();
		$('.gpeu-pause-sending, .gpeu-resume-sending').toggle();
	};

	resume = (event: Event) => {
		event.preventDefault();

		this.queue.resume();
		$('.gpeu-pause-sending, .gpeu-resume-sending').toggle();
	};

	sendEmails = (event: Event) => {
		/* Warn when leaving. */
		window.onbeforeunload = function() {
			return true;
		};

		$(
			'.gpeu-please-review, #gform-settings-gpeu-send, #gform-settings-gpeu-go-back'
		).remove();

		$('.gpeu-sending_count, .gpeu-pause-sending').show();

		if (window.gpeuEmails.length > 20) {
			$('.gpeu-sending-bottom').show();
		}

		for (const email of window.gpeuEmails) {
			this.queue.push(email);
		}

		event.preventDefault();
	};

	taskQueued = (taskId: any, task: Email) => {
		this.setStatus(task, window.GPEU.strings.queued);
	};

	taskFinish = (taskId: any, email: Email) => {
		this.setStatus(email, window.GPEU.strings.sent);
	};

	taskFailed = (taskId: any, error: any) => {
		this.setStatus(error.email, window.GPEU.strings.error);

		const $currentErrors = $('.gpeu-sending_count_errors');
		const $currentErrorsCount = $currentErrors.find('.current-errors');
		const currentErrorCount = parseInt($currentErrorsCount.first().text());

		$currentErrors.show();
		$currentErrorsCount.text(currentErrorCount + 1);

		console.error('Failed to send email.', { error });
	};

	updateCounter = () => {
		const { total } = this.queue.getStats();

		$('.gpeu-sending .current').text(total);
	};

	/**
	 * Runs when the queue is finished/empty.
	 */
	drain = () => {
		/* Allow navigation away from page without warning. */
		window.onbeforeunload = null;

		const $sending = $('.gpeu-sending');

		$sending.find('.gpeu-sending_count').hide();
		$sending.find('.gpeu-all_done').show();

		if (
			$('.current-errors')
				.first()
				.text() === '0'
		) {
			$sending
				.removeClass('gforms_note_info')
				.addClass('gforms_note_success');
		}

		$('.gpeu-pause-sending, .gpeu-resume-sending').hide();
	};

	getStatusColumn = (email: Email): JQuery<HTMLElement> => {
		return $('#gpeu-email-entry-' + email.entry_id).find(
			'.gpeu-email-column-status'
		);
	};

	setStatus = (email: Email, status: string): void => {
		this.getStatusColumn(email).html(status);
	};

	/**
	 * Processing function for better-queue to send individual emails.
	 *
	 * @param  email
	 * @param  cb
	 */
	sendEmail = async (
		email: Email,
		cb: (error?: any, result?: any) => void
	) => {
		this.setStatus(email, window.GPEU.strings.sending);

		try {
			await jQuery
				.post(window.ajaxurl, {
					email,
					debug: this.debug,
					action: 'gweu_send_email',
				})
				.promise();

			cb(null, email);
		} catch (e) {
			(e as any).email = email;

			cb(e);
		}
	};

	handleError = () => {};
}

(window as any).GPEmailUsers = new GPEmailUsers();
